import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "side-menu" }
const _hoisted_2 = { class: "menus" }
const _hoisted_3 = ["onClick", "onMouseover"]
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  key: 0,
  class: "tooltip"
}

import { ref, computed, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'side-menu',
  props: {
    menus: {},
    open: { type: Boolean, default: false },
    width: { default: "4.5rem" },
    background: { default: "#fff" },
    active: { type: Boolean, default: true }
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v317c07d8": (_ctx.width),
  "v954170c0": (_ctx.background)
}))

const router = useRouter();

const props = __props;

const emit = __emit;

const currentRoute = computed(() => router.currentRoute.value.path);

const opened = ref(false);
const tooltip = ref(-1);

function toggleOpen() {
  opened.value = !opened.value;
  emit("open", opened.value);
}

function goToUrl(data: {
  icon: string;
  label: string;
  url: string;
  disabled?: boolean;
}) {
  if (!data.url || data.disabled) return;

  router.push(data.url);
}

watchEffect(() => {
  opened.value = props.open;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("section", {
      class: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleOpen()))
    }, [
      _createVNode(_unref(svgIcon), {
        icon: "bars",
        size: "1.875rem"
      })
    ]),
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menus, (menu, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item", {
            active: currentRoute.value.includes(menu.url),
            disabled: menu.disabled,
          }]),
          onClick: ($event: any) => (goToUrl(menu)),
          onMouseover: ($event: any) => (tooltip.value = index),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (tooltip.value = -1))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(svgIcon), {
              icon: menu.icon,
              size: "1.875rem"
            }, null, 8, ["icon"])
          ]),
          (tooltip.value === index)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(menu.label), 1))
            : _createCommentVNode("", true)
        ], 42, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})